import React from 'react'
import { hydrate, render } from 'react-dom'
import './index.css'
import App from './App.js'
import reportWebVitals from './reportWebVitals.js'
// the bundle is alive: the no-JS reveal failsafe from index.html stands down
if (typeof window !== 'undefined' && window.__lntRevealFailsafe) clearTimeout(window.__lntRevealFailsafe)

const rootElement = document.getElementById('root')

if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement)
} else {
  render(<App />, rootElement)
}

reportWebVitals()
